import React from 'react';
import {getHelmetForMetaTags} from '../../utils/epicGamesUtils';
import {LoadingPage, Page, Section, HighlightPanel, CaseStudies} from 'epic-ue-components';
import {SectionWrapper, HomepageWrapper, NewsSection} from './Homepage.styles';
import {useStore} from '../../stores';
import {useHistory} from 'react-router-dom';

interface Properties {
    pageData: any;
}

const NewsContainer = ({pageData = {}}: Properties) => {
    const [{loading}] = useStore();
    const history = useHistory();
    const bgImage = pageData.bgImg || '';
    const content = pageData.content || {};
    const bottomContent = pageData.bottomContent || {};
    const news = pageData.news || {};
    const panels = news.panels || [];
    const sections = content.sections || [];
    const bottomSections = bottomContent.sections || [];
    const showcase = pageData.showcase || {};

    if (loading) {
        return <LoadingPage />;
    }

    let sectionList = <div />;
    if (sections) {
        sectionList = sections.map((section, i) => {
            let even = false;
            if (i % 2 === 0) {
                even = true;
            }
            return <Section key={`s-${i}-${section.title}`} {...section} even={even} />;
        });
    }

    let bottomSectionList = <div />;
    if (bottomSections) {
        bottomSectionList = bottomSections.map((section, i) => {
            let even = false;
            if (i % 2 === 0) {
                even = true;
            }
            return <Section key={`s-${i}-${section.title}`} {...section} even={even} />;
        });
    }

    let highlightList = <div />;
    if (panels) {
        highlightList = panels.map((panel, i) => {
            return <HighlightPanel history={history} key={`highlight-${i}-${panel.title}`} {...panel} />;
        });
    }

    return (
        <Page>
            {getHelmetForMetaTags(pageData)}
            <HomepageWrapper className="news-container">
                <SectionWrapper bgImg={bgImage}>{sectionList}</SectionWrapper>
                <CaseStudies {...showcase} />
                <NewsSection>
                    <div className="container">
                        <div className="row">{highlightList}</div>
                    </div>
                </NewsSection>
                <SectionWrapper bgImg="">{bottomSectionList}</SectionWrapper>
            </HomepageWrapper>
        </Page>
    );
};

export default NewsContainer;
